﻿import {
    IressCol,
    IressFormField,
    IressFormFieldset,
    IressInputCurrency,
    IressRadio,
    IressRadioGroup,
    IressRow,
} from '@iress-oss/ids-components';
import {
    CURRENCY_CODE, ErrorMessage,
    LOCALE,
    ProjectedMaturityBasisType,
    ProjectedValuesValues,
} from '@xplan-pension-switching/common';
import { FC } from 'react';
import { twoDecimalPlaceRegex } from '../../../helpers/Numbers/TwoDecimalPlaces';

export const ProjectedMaturityBasisFields: FC<{ projectedValues: ProjectedValuesValues }> = ({ projectedValues }) => (
    <>
        <IressFormFieldset
            label="Projection type"
            name="projectedValues.projectionType"
            rules={{ required: ErrorMessage.SelectAnOption }}
            defaultValue={projectedValues?.projectionType}
            data-testid={'bob'}
            render={controlledProps => (
                <IressRadioGroup layout="inline" {...controlledProps}>
                    <IressRadio
                        data-testid="rdMonProjSupplied"
                        value={ProjectedMaturityBasisType.MonetaryProjectionsSupplied}
                    >
                        Monetary projections supplied
                    </IressRadio>
                    <IressRadio
                        data-testid="rdInfAdjSupplied"
                        value={ProjectedMaturityBasisType.InflationAdjustedRatesSupplied}
                    >
                        Inflation adjusted rates supplied
                    </IressRadio>
                </IressRadioGroup>
            )}
        />
        <IressRow gutter="lg">
            <IressCol span="3">
                <IressFormField
                    label="Low rate maturity value"
                    name="projectedValues.lowRateMaturityValue"
                    defaultValue={projectedValues?.lowRateMaturityValue}
                    rules={{
                        required: ErrorMessage.EnterAValue,
                        min: { value: 0.01, message: ErrorMessage.MinGreaterThanZero },
                        pattern: twoDecimalPlaceRegex,
                    }}
                    render={controlledProps => (
                        <IressInputCurrency
                            {...controlledProps}
                            data-testid="txtLowRateMaturityValue"
                            currencyCode={CURRENCY_CODE}
                            locale={LOCALE}
                            placeholder="0.00"
                        />
                    )}
                />
            </IressCol>
            <IressCol span="3">
                <IressFormField
                    label="Mid rate maturity value"
                    name="projectedValues.midRateMaturityValue"
                    defaultValue={projectedValues?.midRateMaturityValue}
                    rules={{
                        required: ErrorMessage.EnterAValue,
                        min: { value: 0.01, message: ErrorMessage.MinGreaterThanZero },
                        pattern: twoDecimalPlaceRegex,
                    }}
                    render={controlledProps => (
                        <IressInputCurrency
                            {...controlledProps}
                            data-testid="txtMidRateMaturityValue"
                            currencyCode={CURRENCY_CODE}
                            locale={LOCALE}
                            placeholder="0.00"
                        />
                    )}
                />
            </IressCol>
            <IressCol span="3">
                <IressFormField
                    label="High rate maturity value"
                    name="projectedValues.highRateMaturityValue"
                    defaultValue={projectedValues?.highRateMaturityValue}
                    rules={{
                        required: ErrorMessage.EnterAValue,
                        min: { value: 0.01, message: ErrorMessage.MinGreaterThanZero },
                        pattern: twoDecimalPlaceRegex,
                    }}
                    render={controlledProps => (
                        <IressInputCurrency
                            {...controlledProps}
                            data-testid="txtHighRateMaturityValue"
                            type="number"
                            currencyCode={CURRENCY_CODE}
                            locale={LOCALE}
                            placeholder="0.00"
                        />
                    )}
                />
            </IressCol>
        </IressRow>
    </>
);
